import React, {
  useState,
} from "react";

import {
  useNavigate,
} from "react-router-dom";

import {
  doc,
  getDoc,
  setDoc,
  serverTimestamp,
} from "firebase/firestore";

import {
  db,
} from "../../../firebase";

import PageLayout from "../../layout/PageLayout";

import "./Coupons.css";

function AddCoupon() {

  const navigate =
    useNavigate();

  const [loading, setLoading] =
    useState(false);

  const [form, setForm] =
    useState({

      code: "",

      title: "",

      description: "",

      couponType: "public",

      rewardType: "contacts",

      rewardValue: "",

      maxUses: "",

      userLimit: 1,

      cooldownDays: 0,

      minimumContactsRequired: 0,

      minimumAppVersion: "",

      onlyNewUsers: false,

      allowExistingUsers: true,

      allowReferralUsers: true,

      image: "",

      startDate: "",

      expiryDate: "",

      active: true,

    });

  /* ==========================================
      HANDLE CHANGE
  ========================================== */

  function handleChange(e) {

    const {
      name,
      value,
      checked,
      type,
    } = e.target;

    setForm((prev) => ({

      ...prev,

      [name]:

        type === "checkbox"

          ? checked

          : value,

    }));

  }

  /* ==========================================
      CREATE COUPON
  ========================================== */

  async function handleSubmit(e) {

    e.preventDefault();

    const code =
      form.code
        .trim()
        .toUpperCase();

    if (!code) {

      alert(
        "Coupon code is required."
      );

      return;

    }

    if (

      new Date(form.expiryDate)

      <=

      new Date(form.startDate)

    ) {

      alert(
        "Expiry date must be after start date."
      );

      return;

    }

    try {

      setLoading(true);

      const couponRef =
        doc(
          db,
          "couponCodes",
          code,
        );

      const existing =
        await getDoc(
          couponRef,
        );

      if (
        existing.exists()
      ) {

        alert(
          "Coupon already exists."
        );

        return;

      }

      const maxUses =
        Number(
          form.maxUses
        );

      const rewardValue =
        Number(
          form.rewardValue
        );

      await setDoc(

        couponRef,

        {

          code,

          title:
            form.title.trim(),

          description:
            form.description.trim(),

          couponType:
            form.couponType,

          rewardType:
            form.rewardType,

          rewardValue,

          rewardTitle:
            `${rewardValue} Contacts`,

          image:
            form.image,

          maxUses,

          usedCount: 0,

          remainingUses:
            maxUses,

          userLimit:
            Number(
              form.userLimit
            ),

          cooldownDays:
            Number(
              form.cooldownDays
            ),

          minimumContactsRequired:
            Number(
              form.minimumContactsRequired
            ),

          minimumAppVersion:
            form.minimumAppVersion,

          onlyNewUsers:
            form.onlyNewUsers,

          allowExistingUsers:
            form.allowExistingUsers,

          allowReferralUsers:
            form.allowReferralUsers,

          totalRewardGiven: 0,

          active:
            form.active,

          status:
            form.active
              ? "active"
              : "inactive",

          startDate:
            new Date(
              form.startDate
            ),

          expiryDate:
            new Date(
              form.expiryDate
            ),

          createdBy:
            "Admin",

          createdAt:
            serverTimestamp(),

          updatedAt:
            serverTimestamp(),

        }

      );

      alert(
        "Coupon created successfully."
      );

      navigate(
        "/admin/coupons"
      );

    } catch (error) {

      console.error(error);

      alert(
        "Failed to create coupon."
      );

    } finally {

      setLoading(false);

    }

  }
  return (

<PageLayout
  title="Add Coupon"
  subtitle="Create promotional coupon."
>

<form
  className="coupon-form"
  onSubmit={handleSubmit}
>

{/* ==========================================
    COUPON INFORMATION
========================================== */}

<div className="coupon-section">

<h3>
🎟 Coupon Information
</h3>

<div className="coupon-grid">

<div className="coupon-field">

<label>
Coupon Code
</label>

<input
name="code"
placeholder="WELCOME5"
value={form.code}
onChange={handleChange}
style={{
textTransform:"uppercase",
}}
required
/>

</div>

<div className="coupon-field">

<label>
Coupon Name
</label>

<input
name="title"
placeholder="Welcome Offer"
value={form.title}
onChange={handleChange}
required
/>

</div>

<div className="coupon-field full-width">

<label>
Description
</label>

<textarea
rows={4}
name="description"
placeholder="New users receive free contacts."
value={form.description}
onChange={handleChange}
/>

</div>

</div>

</div>

{/* ==========================================
    REWARD
========================================== */}

<div className="coupon-section">

<h3>
🎁 Reward
</h3>

<div className="coupon-grid">

<div className="coupon-field">

<label>
Reward Type
</label>

<select
name="rewardType"
value={form.rewardType}
onChange={handleChange}
>

<option value="contacts">
Contacts
</option>

</select>

</div>

<div className="coupon-field">

<label>
Reward Value
</label>

<input
type="number"
min="1"
name="rewardValue"
placeholder="5"
value={form.rewardValue}
onChange={handleChange}
required
/>

</div>

</div>

</div>

{/* ==========================================
    LIMITS
========================================== */}

<div className="coupon-section">

<h3>
📊 Usage Limits
</h3>

<div className="coupon-grid">

<div className="coupon-field">

<label>
Maximum Uses
</label>

<input
type="number"
min="1"
name="maxUses"
value={form.maxUses}
onChange={handleChange}
required
/>

</div>

<div className="coupon-field">

<label>
Per User Limit
</label>

<input
type="number"
min="1"
name="userLimit"
value={form.userLimit}
onChange={handleChange}
required
/>

</div>

<div className="coupon-field">

<label>
Cooldown (Days)
</label>

<input
type="number"
min="0"
name="cooldownDays"
value={form.cooldownDays}
onChange={handleChange}
/>

</div>

<div className="coupon-field">

<label>
Minimum Contacts Required
</label>

<input
type="number"
min="0"
name="minimumContactsRequired"
value={form.minimumContactsRequired}
onChange={handleChange}
/>

</div>

</div>

</div>

{/* ==========================================
    VALIDITY
========================================== */}

<div className="coupon-section">

<h3>
📅 Coupon Validity
</h3>

<div className="coupon-grid">

<div className="coupon-field">

<label>
Start Date
</label>

<input
type="date"
name="startDate"
value={form.startDate}
onChange={handleChange}
required
/>

</div>

<div className="coupon-field">

<label>
Expiry Date
</label>

<input
type="date"
name="expiryDate"
value={form.expiryDate}
onChange={handleChange}
required
/>

</div>

</div>

</div>
{/* ==========================================
    USER RESTRICTIONS
========================================== */}

<div className="coupon-section">

  <h3>
    👤 User Restrictions
  </h3>

  <div className="coupon-grid">

    <div className="coupon-field">

      <label>
        Minimum App Version
      </label>

      <input
        name="minimumAppVersion"
        placeholder="1.0.0"
        value={form.minimumAppVersion}
        onChange={handleChange}
      />

    </div>

    <div className="coupon-field">

      <label>
        Coupon Type
      </label>

      <select
        name="couponType"
        value={form.couponType}
        onChange={handleChange}
      >

        <option value="public">
          Public
        </option>

        <option value="private">
          Private
        </option>

        <option value="referral">
          Referral
        </option>

      </select>

    </div>

  </div>

  <div
    style={{
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit,minmax(250px,1fr))",
      gap: 18,
      marginTop: 25,
    }}
  >

    <label className="coupon-checkbox">

      <input
        type="checkbox"
        name="onlyNewUsers"
        checked={form.onlyNewUsers}
        onChange={handleChange}
      />

      Only New Users

    </label>

    <label className="coupon-checkbox">

      <input
        type="checkbox"
        name="allowExistingUsers"
        checked={form.allowExistingUsers}
        onChange={handleChange}
      />

      Existing Users Allowed

    </label>

    <label className="coupon-checkbox">

      <input
        type="checkbox"
        name="allowReferralUsers"
        checked={form.allowReferralUsers}
        onChange={handleChange}
      />

      Referral Users Allowed

    </label>

    <label className="coupon-checkbox">

      <input
        type="checkbox"
        name="active"
        checked={form.active}
        onChange={handleChange}
      />

      Active Coupon

    </label>

  </div>

</div>

{/* ==========================================
    ACTIONS
========================================== */}

<div className="coupon-actions">

  <button
    type="button"
    className="coupon-btn"
    onClick={() => navigate("/admin/coupons")}
    style={{
      background: "#F3F4F6",
      color: "#374151",
    }}
  >
    Cancel
  </button>

  <button
    type="submit"
    disabled={loading}
    className="coupon-btn coupon-btn-primary"
  >
    {
      loading
        ? "Creating..."
        : "🎟 Create Coupon"
    }
  </button>

</div>

</form>

</PageLayout>

);

}

export default AddCoupon;